"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _phone = require('./phone');

 const phonePattern = /^(\+\d{1,2}[- ]?)?\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/; exports.phonePattern = phonePattern

var PhoneValidationError; (function (PhoneValidationError) {
  const INVALID = 'invalid'; PhoneValidationError["INVALID"] = INVALID;
  const UNSUPPORTED_COUNTRY_CODE = 'unsupported_country_code'; PhoneValidationError["UNSUPPORTED_COUNTRY_CODE"] = UNSUPPORTED_COUNTRY_CODE;
})(PhoneValidationError || (exports.PhoneValidationError = PhoneValidationError = {}));

 const getPhoneValidationError = (value, policy = 'strict') => {
  if (!value) return PhoneValidationError.INVALID

  const phone = _phone.getPhoneHelpers.call(void 0, policy)
  if (phone.hasUnsupportedPhoneCallingCode(value)) {
    return PhoneValidationError.UNSUPPORTED_COUNTRY_CODE
  }

  const trimmedValue = value.trim()
  const digits = _phone.getPhoneDigits.call(void 0, trimmedValue)
  const isExplicitCallingCode = trimmedValue.startsWith('+')
  if (isExplicitCallingCode) {
    const callingCode = phone.getSupportedPhoneCallingCode(trimmedValue)
    const option = phone.getSupportedPhoneCallingCodeOption(callingCode)
    return option && phone.isCompletePhoneInput(option.callingCode, digits.slice(option.callingCode.length)) &&
      digits.length <= option.callingCode.length + option.nationalDigitCount
      ? null
      : PhoneValidationError.INVALID
  }

  const defaultOption = phone.getDefaultPhoneCallingCodeOption()
  return digits.length === defaultOption.nationalDigitCount && exports.phonePattern.test(trimmedValue)
    ? null
    : PhoneValidationError.INVALID
}; exports.getPhoneValidationError = getPhoneValidationError

 const isPhoneValid = (value, policy = 'strict') => {
  return exports.getPhoneValidationError.call(void 0, value, policy) === null
}; exports.isPhoneValid = isPhoneValid
